import styled from "styled-components";

export const MapContainer = styled.div`
  width: 100%;
  height: 100vh;
  position: relative;
`;

export const MapHeader = styled.div`
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  max-width: 480px;
  width: 100%;
  padding: 20px;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
`;

export const BackButton = styled.button`
  position: absolute;
  left: 20px;
  border: none;
  background: rgba(255, 255, 255, 0.9);
  padding: 8px;
  cursor: pointer;
  color: #333;
  font-size: 20px;
  display: flex;
  align-items: center;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const MapTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0;
  background: rgba(255, 255, 255, 0.9);
  padding: 8px 20px;
  border-radius: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const GuideMessage = styled.div`
  position: fixed;
  top: 80px;
  left: 50%;
  transform: translateX(-50%);
  max-width: 340px;
  width: calc(100% - 160px);
  background: white;
  padding: 16px 24px;
  border-radius: 25px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 9;
  text-align: center;
  font-size: 14px;
  color: #333;
`;

export const KakaoMapWrapper = styled.div`
  width: 100%;
  height: 100vh;
`;

export const InfoOverlay = styled.div`
  position: fixed;
  bottom: 90px;
  left: 50%;
  transform: translateX(-50%);
  max-width: 440px;
  width: 90%;
  background-color: white;
  border-radius: 15px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 10;
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const InfoContent = styled.div`
  display: flex;
  gap: 15px;
`;

export const BuildingImage = styled.img`
  width: 100px;
  height: 120px;
  border-radius: 10px;
  object-fit: cover;
  flex-shrink: 0;
`;

export const BuildingInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const InfoTitle = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: #333;
  text-align: left;
`;

export const InfoDetails = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 5px;
  text-align: left;
`;

export const InfoItem = styled.div`
  font-size: 13px;
  color: #666;
  line-height: 1.6;
  text-align: left;
`;

export const InfoAddress = styled.div`
  font-size: 14px;
  color: #666;
  line-height: 1.5;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const InfoButton = styled.button`
  padding: 12px 40px;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 25px;
  font-size: 15px;
  font-weight: bold;
  cursor: pointer;

  &:hover {
    background-color: #45a049;
  }
`;
